import { useNavigate, useParams } from "react-router-dom"
import PageTitle from "../../components/PageTitle";
import PageContent from "../../components/PageContent";
import { useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import useApi from "../../hooks/ApiHook";
import { InputText } from "primereact/inputtext";
import { Checkbox } from 'primereact/checkbox';
import { Button } from "primereact/button";
import useToast from "../../hooks/ToastHook";
import useUser from "../../hooks/UserHook";
import { InputMask } from 'primereact/inputmask';
import { Dropdown } from 'primereact/dropdown';

const taxationTypes = [{
    label: 'Lucro real',
    value: 'REAL_PROFIT'
}, {
    label: 'Lucro presumido',
    value: 'PRESUMED_PROFIT'
}, {
    label: 'Simples Nacional',
    value: 'SN'
}];

const states = [{
	label: 'Acre',
	value: 'AC'
}, {
	label: 'Alagoas',
	value: 'AL'
}, {
	label: 'Amapá',
	value: 'AP'
}, {
	label: 'Amazonas',
	value: 'AM'
}, {
	label: 'Bahia',
	value: 'BA'
}, {
	label: 'Ceará',
	value: 'CE'
}, {
	label: 'Espírito Santo',
	value: 'ES'
}, {
	label: 'Goiás',
	value: 'GO'
}, {
	label: 'Maranhão',
	value: 'MA'
}, {
	label: 'Mato Grosso',
	value: 'MT'
}, {
	label: 'Mato Grosso do Sul',
	value: 'MS'
}, {
	label: 'Minas Gerais',
	value: 'MG'
}, {
	label: 'Pará',
	value: 'PA'
}, {
	label: 'Paraíba',
	value: 'PB'
}, {
	label: 'Paraná',
	value: 'PR'
}, {
	label: 'Pernambuco',
	value: 'PE'
}, {
	label: 'Piauí',
	value: 'PI'
}, {
	label: 'Rio de Janeiro',
	value: 'RJ'
}, {
	label: 'Rio Grande do Norte',
	value: 'RN'
}, {
	label: 'Rio Grande do Sul',
	value: 'RS'
}, {
	label: 'Rondônia',
	value: 'RO'
}, {
	label: 'Roraima',
	value: 'RR'
}, {
	label: 'Santa Catarina',
	value: 'SC'
}, {
	label: 'São Paulo',
	value: 'SP'
}, {
	label: 'Sergipe',
	value: 'SE'
}, {
	label: 'Tocantins',
	value: 'TO'
}, {
	label: 'Distrito Federal',
	value: 'DF'
}];

const newClient = {
    taxationType: taxationTypes[0].value
}

export default function() {

    const { id } = useParams();
    const navigate = useNavigate();
    const api = useApi();
    const { showSuccess, showAxiosError } = useToast();
    const [ loading, setLoading ] = useState(true);
    const [ saving, setSaving ] = useState(false);
    const [ client, setClient ] = useState(newClient);
    const [ address, setAddress ] = useState({});
    const isNew = id === 'new';

    useState(() => {
        if (isNew) {
            setLoading(false);
            return;
        }
        setLoading(true);
        api.get('clients/' + id).then(({ data }) => {
            setClient(data);
            setAddress(data.address)
        }).finally(() => setLoading(false));
    }, [id]);

    const save = e => {
        setSaving(true);
        const payload = { ...client, address };
        const request = isNew ? api.post('clients', payload) : api.put('clients/' + id, payload);
        request.then(() => {
            showSuccess('Salvo com sucesso');
            navigate(-1);
        }).catch(showAxiosError).finally(() => setSaving(false));
        e.preventDefault();
    }

    return (
        <div>
            <PageTitle title={`${isNew ? 'Novo' : 'Edição de'} cliente`}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <form onSubmit={save}>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label>Razão social</label>
                                <InputText
                                    value={client.corporateName || ''}
                                    maxLength={100}
                                    onChange={e => setClient({ ...client, corporateName: e.target.value })}
                                    className="w-full"
                                    placeholder="Empresa LTDA"/>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label>Nome fantasia</label>
                                <InputText
                                    value={client.commercialName || ''}
                                    maxLength={100}
                                    onChange={e => setClient({ ...client, commercialName: e.target.value })}
                                    className="w-full"
                                    placeholder="Empresa"/>
                            </div>
                            <div className="field col-12 md:col-3">
                                <label>CPF/CNPJ</label>
                                <InputMask
                                    value={client.document} 
                                    unmask
                                    required
                                    onChange={e => setClient({ ...client, document: e.target.value })} 
                                    mask={client?.document?.length === 11 ? "999.999.999-99?9" : "99.999.999/9999-99"} 
                                    placeholder="CPF/CNPJ"
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-3">
                                <label>Inscrição Estadual</label>
                                <InputMask
                                    value={client.ie} 
                                    unmask
                                    required
                                    onChange={e => setClient({ ...client, ie: e.target.value })} 
                                    mask="9?999999999999999"
                                    placeholder="Inscrição Estadual"
                                    slotChar=" "
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-2">
                                <label>Modelo tributário</label>
                                <Dropdown 
                                    value={client.taxationType} 
                                    onChange={e => setClient({ ...client, taxationType: e.value })} 
                                    options={taxationTypes}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label>Email</label>
                                <InputText
                                    value={client.email || ''}
                                    maxLength={50}
                                    onChange={e => setClient({ ...client, email: e.target.value })}
                                    placeholder="empresa@email.com"
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-3">
                                <label>Telefone</label>
                                <InputMask
                                    value={client.phone} 
                                    unmask
                                    required
                                    onChange={e => setClient({ ...client, phone: e.target.value })} 
                                    mask={client?.phone?.length === 10 ? "(99) 9999-9999?9" : "(99) 99999-9999"} 
                                    placeholder="(99) 99999-9999"
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-3">
                                <label>CEP</label>
                                <InputMask
                                    value={address.cep || ''} 
                                    unmask
                                    required
                                    onChange={e => setAddress({ ...address, cep: e.target.value })} 
                                    slotChar=" "
                                    mask="?99999999999" 
                                    placeholder="9999999"
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-2">
                                <label>Estado</label>
                                <Dropdown 
                                    value={address.state} 
                                    onChange={e => setAddress({ ...address, state: e.value })} 
                                    options={states}
                                    className="w-full"
                                    placeholder="São Paulo"/>
                            </div>
                            <div className="field col-12 md:col-4">
                                <label>Cidade</label>
                                <InputText
                                    value={address.city || ''}
                                    maxLength={50}
                                    onChange={e => setAddress({ ...address, city: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-3">
                                <label>Bairro</label>
                                <InputText
                                    value={address.district || ''}
                                    maxLength={50}
                                    onChange={e => setAddress({ ...address, district: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-3">
                                <label>Rua</label>
                                <InputText
                                    value={address.street || ''}
                                    maxLength={50}
                                    onChange={e => setAddress({ ...address, street: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-1">
                                <label>Número</label>
                                <InputText
                                    value={address.number || ''}
                                    maxLength={5}
                                    onChange={e => setAddress({ ...address, number: e.target.value })}
                                    type="number"
                                    className="w-full"/>
                            </div>
                            <div className="field col-12 md:col-5">
                                <label>Complemento</label>
                                <InputText
                                    value={address.complement || ''}
                                    maxLength={100}
                                    onChange={e => setAddress({ ...address, complement: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field-checkbox col-12">
                                <Checkbox 
                                    checked={client.icmsContributor}
                                    onChange={e => setClient({ ...client, icmsContributor: e.checked })}/>
                                <label for="city1">Contribuinte do ICMS</label>
                            </div>
                        </div>
                        <div className="mt-2">
                            <Button 
                                className="mr-2" 
                                label="Salvar"
                                loading={saving}/>
                            <Button 
                                label="Cancelar" 
                                outlined
                                type="button"
                                disabled={saving}
                                onClick={() => navigate(-1)}/>
                        </div>
                    </form>
                </If>
            </PageContent>
        </div>
    );
}